import { TextInput as MantineTextInput, TextInputProps } from '@mantine/core'

export const TextInput = (props: TextInputProps) => (
  <MantineTextInput {...props} />
)
